// ✅ Add to cart (AJAX) + Open UpCart
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.collection-cart');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const variantId = btn.getAttribute('data-variant-id');
  if (!variantId) return;

  const label = btn.querySelector('span');
  const oldLabelText = label ? label.textContent : btn.textContent;

  // loading state
  btn.classList.add('is-loading');
  btn.setAttribute('aria-busy', 'true');
  if (label) label.textContent = 'Adding...';

  const root =
    (window.Shopify && Shopify.routes && Shopify.routes.root)
      ? Shopify.routes.root
      : '/';

  const addUrl = `${root}cart/add.js`;

  try {
    const res = await fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || 'Add to cart failed');
    }

    // ✅ Open UpCart
    const stickyBtn = document.querySelector('#upCartStickyButton');
    if (stickyBtn) stickyBtn.click();

    const cartPopup = document.getElementById('CartPopup');
    if (cartPopup) {
      cartPopup.setAttribute('aria-hidden', 'false');
      cartPopup.style.pointerEvents = 'auto';
    }

    if (label) label.textContent = 'Added!';
    setTimeout(() => {
      if (label) label.textContent = oldLabelText;
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    }, 900);

  } catch (err) {
    console.error('ATC Error:', err);
    if (label) label.textContent = 'Error, try again';

    setTimeout(() => {
      if (label) label.textContent = oldLabelText;
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    }, 1400);
  }
});
